
import React, { Fragment } from 'react'
import {AppButton,AppRow} from 'qcc'
import {DemoApiTable} from './DemoApiTable'
import { Row, Icon } from 'antd';

const apiData = [
    {attrName:'type',type:'枚举值：default、primary、dangerous、link',defaultValue:'default',remarks:'属性type来确定不同的按钮样式。'},
    {attrName:'label',type:'string',defaultValue:'',remarks:'按钮的内容'},
    {attrName:'width',type:'number',defaultValue:'100',remarks:'按钮的宽度'},
    {attrName:'actionCode',type:'string',defaultValue:'',remarks:'功能点代码，和系统设置的功能权限点绑定，可以确定功能按钮的显示'},
    {attrName:'action',type:'() => void',defaultValue:'',remarks:'按钮的点击事件'},
    {attrName:'iconType',type:'string',defaultValue:'',remarks:'按钮的前面的图标，只支持antd的图标文字'},
    {attrName:'loading',type:'boolean',defaultValue:'false',remarks:'设置按钮载入状态'},
]

const itemApiData = [
    {attrName:'label',type:'string',defaultValue:'',remarks:'按钮的内容'},
    {attrName:'actionCode',type:'string',defaultValue:'',remarks:'功能点代码，和系统设置的功能权限点绑定，可以确定功能按钮的显示'},
    {attrName:'action',type:'() => void',defaultValue:'',remarks:'按钮的点击事件'}
]


export const AppButtonDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、操作按钮，需要用户界面交互时使用。<br/>
                2、每个类型的按钮都建议设置actionCode，用于权限过滤。<br/>
                3、属性type来确定不同的按钮样式。<br/>
                4、引用：import {`{AppButton}`} from 'qcc'<br/>
                5、demo位置：src/demo/components/AppButtonDemo.tsx
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo'>
                <Row  className="demo-title"><label>一般按钮</label></Row>
                <Row style={{padding:20}}>
                    <AppRow>
                        <AppButton label='default' />
                        <AppButton label='primary' type='primary'/>
                        <AppButton label='dangerous' type='dangerous'/>
                    </AppRow>
                </Row>
                <Row style={{padding:20}}>
                    <AppRow>
                        <AppButton label='default' iconType='plus'/>
                        <AppButton label='primary' type='primary' iconType='edit'/>
                        <AppButton label='dangerous' type='dangerous' iconType='delete'/>
                    </AppRow>
                </Row>
                <Row style={{padding:20}}>
                    <AppRow>
                        <AppButton label='default' loading/>
                        <AppButton label='primary' type='primary' loading/>
                        <AppButton label='dangerous' type='dangerous' loading/>
                    </AppRow>
                </Row>
                <Row  className="demo-title"><label>下拉按钮</label></Row>
                <Row style={{padding:20}}>

                    <AppButton label='更多操作'>
                        <AppButton.Item label='daochu'/>
                        <AppButton.Item label='daochu'/>
                        <AppButton.Item label='daochu'/>
                        <AppButton.Item label='daochu'/>
                    </AppButton> 
                    
                </Row>

                 <Row  className="demo-title"><label>table的按钮：type=link</label></Row>
                 <Row style={{padding:20}}>
                    <AppRow itemSplit={10}>
                        <AppButton type='link' label='编辑' />
                        <AppButton type='link' label='删除' />
                        <AppButton type='link' label='更多操作' >
                            <AppButton.Item label='daochu'/>
                            <AppButton.Item label='daochu'/>
                            <AppButton.Item label='daochu'/>
                            <AppButton.Item label='daochu'/>
                        </AppButton>
                    </AppRow>
                 </Row>
                
            </div>
            
            <h1>API</h1>
            <h2>AppButton api</h2>
             <DemoApiTable data={apiData}/>

              <h2>AppButton.Item api</h2>
             <DemoApiTable data={itemApiData}/>
    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppButtonDemo.tsx